import type { ScriptLane } from '../../types/script'
import { getStepNumber } from './laneUtils'

export type BranchDestination =
  | { kind: 'end' }
  | { kind: 'rejoin'; targetClientId: string; stepNumber: number | null }

/**
 * Where a branch lane goes when it finishes: rejoin a later step, or end the script.
 * Source of truth for the terminus display and the flow-wire router.
 */
export function getBranchDestination(lane: ScriptLane, lanes: ScriptLane[]): BranchDestination {
  if (lane.mergeTargetClientId) {
    return {
      kind: 'rejoin',
      targetClientId: lane.mergeTargetClientId,
      stepNumber: getStepNumber(lanes, lane.mergeTargetClientId),
    }
  }
  return { kind: 'end' }
}
